import { render, staticRenderFns } from "./UpdateServicePackageModal.vue?vue&type=template&id=fc136b8e&scoped=true&"
import script from "./UpdateServicePackageModal.vue?vue&type=script&lang=js&"
export * from "./UpdateServicePackageModal.vue?vue&type=script&lang=js&"
import style0 from "./UpdateServicePackageModal.vue?vue&type=style&index=0&id=fc136b8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc136b8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc136b8e')) {
      api.createRecord('fc136b8e', component.options)
    } else {
      api.reload('fc136b8e', component.options)
    }
    module.hot.accept("./UpdateServicePackageModal.vue?vue&type=template&id=fc136b8e&scoped=true&", function () {
      api.rerender('fc136b8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ProcessChargesAgGrid/components/UpdateServicePackageModal.vue"
export default component.exports